.statContainer {
  height: 217px;
  width: 217px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--static-background-weak);
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid var(--static-divider-standard);
  text-align: center;
}

.statHeader {
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 10px;
  color: var(--color-primary);
}

.statSubHeader {
  margin-bottom: 10px;
}